import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';

import { IElement } from 'bom/types';
import { EditElementButton } from 'jobs/components/JobDetails';
import { IJob } from 'jobs/types';
import { Color, Direction, Level } from 'theme/enums';

interface IProps extends ICellRendererParams {
  job: IJob;
  isEditable: (data: IElement) => boolean;
}

export const ActionsCell = ({ data, job, isEditable }: IProps) => {
  const isRowEditable = isEditable(data);

  if (!data) {
    return null;
  }

  return (
    <Stack direction={Direction.ROW} gap={1}>
      {isRowEditable && (
        <EditElementButton
          job={job}
          element={data}
          buttonElement={
            <Typography color={Color.PRIMARY} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
              <PencilSimpleLine />
            </Typography>
          }
        />
      )}
    </Stack>
  );
};
